// extracted by mini-css-extract-plugin
export default {"task-confirmatory-deadline":"styles_task-confirmatory-deadline__SmOri"};